/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Leave Service API
 * Leave management microservice (multi-step approvals, delegation, holidays)
 * OpenAPI spec version: v1
 */

/**
 * Approval scenario: SCENARIO_A (Manager→Director→HR→CEO) or SCENARIO_B (Manager→HR→CEO)
 */
export type DirectorateApprovalScenario =
  (typeof DirectorateApprovalScenario)[keyof typeof DirectorateApprovalScenario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectorateApprovalScenario = {
  SCENARIO_A: "SCENARIO_A",
  SCENARIO_B: "SCENARIO_B",
} as const;
